export default {
  meta: {
    title: '权限管理',
    url: '/organization/permission', // 埋点用，记录所属模块
    // eventId: '27af58e0-740a-440a-a7b3-42f7bf2c4711'
  }
};
